
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit(e, page) {
      const $$ = this.$;
      function todayIso() {
        var d = new Date();
        var y = d.getFullYear();
        var m = String(d.getMonth() + 1).padStart(2, '0');
        var dd = String(d.getDate()).padStart(2, '0');
        return y + '-' + m + '-' + dd;
      }
      function applyFilter(filter) {
        var today = todayIso();
        var $cards = $$('#appointmentList .appt-card');
        var visibleCount = 0;
        $cards.each(function () {
          var date = $$(this).attr('data-date') || '';
          var show = true;
          if (filter === 'upcoming') {
            show = !!date && date >= today;
          } else if (filter === 'past') {
            show = !!date && date < today;
          }
          if (show) {
            $$(this).css('display', '');
            visibleCount++;
          } else {
            $$(this).css('display', 'none');
          }
        });
        if ($cards.length > 0 && visibleCount === 0) {
          $$('#apptFilterEmpty').show();
        } else {
          $$('#apptFilterEmpty').hide();
        }
      }
      $$('#appointmentListPage .appt-filter-chip').on('click', function () {
        var $btn = $$(this);
        $$('#appointmentListPage .appt-filter-chip').removeClass('is-active');
        $btn.addClass('is-active');
        applyFilter($btn.attr('data-filter'));
      });
    }
  },
  id: '9007f9beb3',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page appointment-list-page" id="appointmentListPage" data-name="appointment">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="/home/" class="link" aria-label="Back to home">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">Appointments</div>\n            </div>\n        </div>\n        <div class="page-content">\n            <!-- Filter chips -->\n            <div class="appt-filter-row">\n                <button type="button" class="appt-filter-chip is-active" data-filter="all">All</button>\n                <button type="button" class="appt-filter-chip" data-filter="upcoming">Upcoming</button>\n                <button type="button" class="appt-filter-chip" data-filter="past">Past</button>\n            </div>\n\n            <div class="appt-list" id="appointmentList">\n                ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data.data, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <a href="/appointmentDetails/';
          r += c(ctx_2.id, ctx_2);
          r += '/" class="appt-card link" data-date="';
          r += c(ctx_2.date_iso, ctx_2);
          r += '" aria-label="View appointment details">\n                    <div class="appt-card-head">\n                        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.is_bookConfirmed, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <span class="appt-status appt-status-confirmed">\n                            <i class="icon f7-icons if-not-md">checkmark_seal_fill</i>\n                            <i class="icon material-icons md-only">verified</i>\n                            Confirmed\n                        </span>\n                        ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n                        <span class="appt-status appt-status-pending">\n                            <i class="icon f7-icons if-not-md">clock</i>\n                            <i class="icon material-icons md-only">schedule</i>\n                            Pending\n                        </span>\n                        ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                        <span class="appt-card-id">ID #';
          r += c(ctx_2.pre, ctx_2);
          r += c(ctx_2.id, ctx_2);
          r += '</span>\n                    </div>\n\n                    <div class="appt-card-body">\n                        <div class="appt-card-photo">\n                            <img src="';
          r += Template7Helpers.if.call(ctx_2, ctx_2.doctorPhoto, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += c(ctx_3.doctorPhoto, ctx_3);
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += 'static/img/default_doctor.svg';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '" alt="" onerror="this.src=\'static/img/default_doctor.svg\'">\n                        </div>\n                        <div class="appt-card-info">\n                            <div class="appt-card-doctor">Dr. ';
          r += c(ctx_2.doctorName, ctx_2);
          r += '</div>\n                            ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.depName, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                            <div class="appt-card-dept">';
              r += c(ctx_3.depName, ctx_3);
              r += '</div>\n                            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n                            <div class="appt-card-when">\n                                <i class="icon f7-icons if-not-md">calendar</i>\n                                <i class="icon material-icons md-only">event</i>\n                                <span>';
          r += c(ctx_2.day, ctx_2);
          r += ', ';
          r += c(ctx_2.date, ctx_2);
          r += ' ';
          r += c(ctx_2.month, ctx_2);
          r += Template7Helpers.if.call(ctx_2, ctx_2.time, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' \xB7 ';
              r += c(ctx_3.time, ctx_3);
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</span>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class="appt-card-foot">\n                        <span class="appt-card-amount">\u20B9 ';
          r += c(ctx_2.payableAmount, ctx_2);
          r += '</span>\n                        <span class="appt-card-cta">\n                            <span>View</span>\n                            <i class="icon f7-icons if-not-md">chevron_right</i>\n                            <i class="icon material-icons md-only">chevron_right</i>\n                        </span>\n                    </div>\n                </a>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            </div>\n\n            <!-- No-bookings empty state -->\n            ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.data.data, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="empty-state">\n                <img src="static/img/no_doctor.svg" alt="">\n                <div class="empty-state-title">No appointments yet</div>\n                <div class="empty-state-sub">When you book a doctor, your appointments will show up here.</div>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            <!-- Filtered empty state -->\n            <div class="empty-state appt-filter-empty" id="apptFilterEmpty" style="display: none;">\n                <img src="static/img/no_doctor.svg" alt="">\n                <div class="empty-state-title">No appointments in this filter</div>\n                <div class="empty-state-sub">Try a different filter to see other appointments.</div>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    